import { utilGrid } from "../utils/grid/utilGrid";
export var getBuildingIsoVolume = function (data, display) {
    var topCenter = utilGrid.screenToMap(display.width * 0.5, -display.height);
    return Math.floor(Math.min(topCenter.x, topCenter.y)) - 1;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/getBuildingIsoVolume.ts
// module id = 2207
// module chunks = 3